import {put,takeLatest,call} from 'redux-saga/effects';
import {  withCallback } from 'redux-saga-callback';
import * as orderService from "../../../services/orderService";
import {
    PLACE_ORDER,
    PLACE_ORDER_SUCCESS,
    PLACE_ORDER_ERROR,
}
    from "../../actions/order";

function* placeOrderSaga(action) {
    try {
       const data  = yield call(orderService.PlaceOrder,action.payload)
        
       yield put({
        type: PLACE_ORDER_SUCCESS,
        payload: data
    });

        return data

    } catch (error) {
        yield put({
            type: PLACE_ORDER_ERROR,error: error.data
        });
    }
}


export function* placeOrderSagaWatcher() {
    yield takeLatest(PLACE_ORDER, withCallback(placeOrderSaga));
}